import * as actions from './actions'
import { ActionType, createReducer } from 'typesafe-actions'

export interface FilterType {
  numberOfResults: number
  isSortedAscending: boolean
}

export const filter = createReducer<FilterType, ActionType<typeof actions>>({
  numberOfResults: 10,
  isSortedAscending: true
})
  .handleAction(
    [actions.showMoreLines, actions.showLessLines],
    (state, { payload, type }) => ({
      ...state,
      numberOfResults:
        state.numberOfResults + (type === 'SHOW_MORE_LINES' ? 1 : -1) * payload
    })
  )
  .handleAction(actions.flipSortOrder, state => ({
    ...state,
    isSortedAscending: !state.isSortedAscending
  }))

export default filter
